<template>
    <div class="form-group row"
         v-bind:class="{ 'has-danger': error }">
        <div class="form-control-input"
             v-bind:class="'col-md-12'">
            <slot></slot>
            <small class="invalid-feedback d-block"
                   v-show="error">
                {{ error }}
            </small>
        </div>
        <div v-show="helpText"
             class="col-2 col-md-1 align-self-center">
            <a tabindex="-1"
               class="btn btn-xs btn-round btn-outline-info w-20 h-20"
               data-toggle="popover"
               data-trigger="focus"
               data-html="true"
               :title="helpTitle"
               :data-content="helpText">
                <i class="fa fa-question"></i>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        error: {
            type: String,
            required: false,
        },
        helpTitle: {
            type: String,
            required: false,
        },
        helpText: {
            type: String,
            required: false,
        },
    }
}
</script>

<style scoped>

</style>
